
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certification-vouchers/[slug]",
      function () {
        return require("private-next-pages/certification-vouchers/[slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certification-vouchers/[slug]"])
      });
    }
  